import React, { useState } from "react"
import { ReactComponent as StockIcon } from "../../../images/icons/warehouse.svg"
import { Maybe, Stock } from "lib/types/generated/graphql-types"
import InventoryRow from "./InventoryRow"
import Status from "../../Ui/Status"
import { TooltipIcon } from "../../Ui/TooltipIcon"
import { WithAuth } from "../../Auth"
import { PermissionGroups } from "../../../routes/constants"
import IncomingStockRow from "./IncomingStockRow"
import { Arrow, Tab, ValidateStock } from "./Shared.styled"


type Props = {
  stock: Maybe<Stock> | undefined
  variantId: string
}

export const ProductVariantStock = ({ stock, variantId }: Props) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  const toValidateStock = (stockData: Maybe<Stock> | undefined) => {
    if ((stockData !== null) !== undefined) {
      return (
        <>
          <ValidateStock>
            Validate stock:
            {stockData?.validateStock ? (
              <Status status={"Enabled"} />
            ) : (
              <Status status={"Disabled"} />
            )}
            <TooltipIcon content="Validation of stock quantity in cart to prevent overselling" />
          </ValidateStock>
          {stockData?.inventories.map((inventory) => (
            <InventoryRow
              key={inventory.inventoryId}
              inventoryId={inventory.inventoryId}
              stock={inventory.quantity}
              created={inventory.created}
              updated={inventory.updated}
            />
          ))}
          <WithAuth
            requiredGroups={PermissionGroups.products.read}
            configKey={"incomingStockEnabled"}
          >
            <IncomingStockRow productVariantId={variantId} />
          </WithAuth>
        </>
      )
    }
    return <Status status={"Missing stock data"} />
  }

  return (
    <>
      <Tab onClick={() => setExpanded(!expanded)} $expanded={expanded}>
        <StockIcon />
        <h4>Stock: {stock?.stockQuantity}</h4>
        <Arrow $expanded={expanded} />
      </Tab>
      {expanded && <>{toValidateStock(stock)}</>}
    </>
  )
}
